export default __webpack_public_path__ + "static/media/image16.9472fe85.svg";